import React, { Component } from 'react';
import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';
import { SliderMonitor } from '@redux-devtools/slider-monitor';
const SliderWrapper = styled.div `
  border-color: ${(props) => props.theme.base02};
  border-style: solid;
  border-width: 1px 0;
`;
class Slider extends Component {
    shouldComponentUpdate(nextProps) {
        return (nextProps.liftedState !== this.props.liftedState ||
            nextProps.theme.scheme !== this.props.theme.scheme);
    }
    render() {
        return (React.createElement(SliderWrapper, { className: "slider" },
            React.createElement(SliderMonitor, { ...this.props.liftedState, 
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                dispatch: this.props.dispatch, theme: this.props.theme, hideResetButton: true })));
    }
}
export default withTheme(Slider);
